import React, {Component} from "react";
import Loading from "../../Loading";
import {Link} from "react-router-dom";
import axios from "axios";
import BPContestFileRowByAGBBO from "./BPContestFileRowByAGBBO";

class BPPhaseDetailByAGBBO extends Component{
    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            id:null,
            contestId:null,
            confirmId:null,
            name:'',
            description:'',
            bankCode:'',
            resultFinal:'Other',
            commentContent:'',
            files:[],
        }
        this.state = {
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
            files: [],
        }
        this.handleLoadPhase = this.handleLoadPhase.bind(this);
        this.handleLoadFiles = this.handleLoadFiles.bind(this);
        this.handleLoadConfirm = this .handleLoadConfirm.bind(this);
        this.handleLoadData = this.handleLoadData.bind(this);
        this.handleLoadMessage = this.handleLoadMessage.bind(this);
        this.handleChangeResultFinal = this.handleChangeResultFinal.bind(this);
        this.handleChangeComment = this.handleChangeComment.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.handleLoadData(this.props?.id);
    }

    handleLoadData = (phaseId) =>{
        this.handleLoadPhase(phaseId);
        this.handleLoadFiles(phaseId);
        this.handleLoadConfirm(phaseId);
    }
    handleLoadPhase(phaseId) {
        const {item} = this.state;
        this.setState({isLoading: true})
        axios.get('/api/bankportal/contest/phase/'+phaseId+'/load')
            .then(response =>{
                if(response?.data === ''){
                    this.setState({ errorMessage: 'Không tìm thấy dữ liệu !',successMessage:'',isLoading: false})
                    return;
                }
                item.id = response?.data?.id
                item.name = response?.data?.name
                item.description = response?.data?.description
                item.contestId = response?.data?.contestId
                item.bankCode = response?.data?.bankCode
                this.setState({item: item, errorMessage: '',successMessage:'', isLoading: false});
            })
            .catch(error =>{
                console.error('Error loading phase!', error)
                this.setState({errorMessage: error.message, successMessage: '', isLoading: false})
            })
    }

    handleLoadFiles = (phaseId) =>{
        const {item} = this.state;
        axios.get('/api/bankportal/contest/phase/'+phaseId+'/file/list')
            .then(response =>{
                item.files = response?.data?.listFileUpload
                this.setState({item: item})
            })
            .catch(error =>{
                console.error('Error loading files!', error)
                this.setState({errorMessage: error.message, successMessage: ''})
            })
    }
    handleLoadConfirm = (phaseId) =>{
        const {item} = this.state;
        axios.get('/api/bankportal/contest/confirm/phase/'+phaseId+'/load')
            .then(response =>{
                if(response?.data === ''){
                    item.resultFinal = 'Other'
                    item.commentContent = ''
                }else{
                    item.resultFinal = response?.data?.resultFinal
                    item.commentContent = response?.data?.commentContent
                    item.confirmId = response?.data?.id
                }
                this.setState({item: item})
            })
            .catch(error =>{
                console.error('Error loading phase confirm!', error)
                this.setState({errorMessage: error.message, successMessage: ''})
            })
    }

    handleLoadMessage = (message) =>{
        this.setState({successMessage: message})
    }

    handleLoading = (loading) =>{
        this.setState({isLoading: loading})
    }

    handleChangeResultFinal = (e) =>{
        const { item } = this.state;
        item.resultFinal = e.target.value;
        this.setState({item:item});
    }

    handleChangeComment = (e) =>{
        const { item } = this.state;
        item.commentContent = e.target.value;
        this.setState({item:item});
    }
    handleSubmit = () =>{
        const {item} = this.state;
        console.log('resultFinal:'+item?.resultFinal);
        console.log('commentContent:'+item?.commentContent);
        if(item?.resultFinal === 'Other' && item?.commentContent === ''){
            this.setState({errorMessage:'Vui lòng nhập nội dung phản hồi!', successMessage: ''});
            return;
        }

        this.setState({errorMessage:''});
        const formData = new FormData();
        formData.append('contestId', item?.contestId);
        formData.append('contestPhaseId', item?.id);
        formData.append('resultFinal', item?.resultFinal);
        formData.append('commentContent', item?.commentContent);
        this.setState({isLoading: true});
        axios.post('/api/bankportal/contest/phase/confirm/bo',formData)
            .then(response =>{
                if(response?.data?.id === null){
                    this.setState({errorMessage: 'Xảy ra lỗi khi xác nhận!',successMessage: '', isLoading: false})
                }else{
                    this.handleLoadConfirm(item?.id);
                    this.setState({errorMessage: '',successMessage: 'Xác nhận thành công', isLoading: false})
                }
            })
            .catch(error =>{
                console.error('ERROR',error);
                this.setState({errorMessage: error.message,successMessage: '', isLoading: false})
            })
    }


    render() {
        const {item, isLoading,errorMessage, successMessage} = this.state;
        if(isLoading === true) return <Loading />;
        return (
            <div className={'container'}>
                <div>
                    <div>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">THÔNG TIN CHI TIẾT - ĐỢT</h2>
                        <form>
                            <input type="hidden" value={item?.id} />
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Ngân hàng :</label>
                                <div className="col-sm-9">
                                    <span>{item?.bankCode === 'AGB'?'Agribank':''}</span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Tên đợt :</label>
                                <div className="col-sm-9">
                                    <span>{item?.name}</span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="description">Mô tả :</label>
                                <div className="col-sm-9">
                                    <span>{item?.description}</span>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="status">Danh sách báo cáo :</label>
                                <div className="col-sm-9">
                                    <table className={'table table-bordered table-hover'}>
                                        <thead className='bg-secondary text-white'>
                                        <tr>
                                            <th>STT</th>
                                            <th>Tiêu đề báo cáo</th>
                                            <th>Loại báo cáo</th>
                                            <th>Ngày tạo</th>
                                            <th>Thao tác</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!!item?.files && item?.files.map((file, index) =>
                                            <BPContestFileRowByAGBBO
                                                key={'File_'+file?.id}
                                                item={file}
                                                index={index}
                                                onLoadMessage={this.handleLoadMessage}
                                                onLoading={this.handleLoading}
                                                onLoadFiles={this.handleLoadFiles}
                                                contestPhaseId={item?.id} />
                                        )
                                        }
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="resultFinal">Xác nhận kết quả :</label>
                                <div className="col-sm-9">
                                    {!item?.confirmId &&
                                    <select id="status" className="form-control w-50"
                                        value={item?.resultFinal}
                                        onChange={this.handleChangeResultFinal}
                                    >
                                        <option value="Other">Kết quả khác</option>
                                        <option value="OK">Xác nhận kết quả đúng</option>
                                    </select>
                                    }
                                    {!!item?.confirmId &&
                                    <select disabled={true} id="status" className="form-control w-50"
                                            value={item?.resultFinal}>
                                        <option value="Other">Kết quả khác</option>
                                        <option value="OK">Xác nhận kết quả đúng</option>
                                    </select>
                                    }
                                </div>

                            </div>
                            <div className={'form-group row'}>
                                <label className={'control-label col-sm-3'} htmlFor={'comment'}>Phản hồi từ chi nhánh</label>
                                <div className={'col-sm-9'}>
                                    {!item?.confirmId &&
                                        <textarea maxLength={1000}
                                              value={item?.commentContent}
                                              className={'form-control'}
                                              onChange={this.handleChangeComment}
                                     />
                                    }
                                    {!!item?.confirmId &&
                                    <textarea maxLength={1000}
                                              disabled={true}
                                              value={item?.commentContent}
                                              className={'form-control'}
                                    />
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/contest/'+item?.contestId+'/detail'} className="btn btn-success">Quay về</Link>
                                    {!item?.confirmId &&
                                    <button type="button" onClick={this.handleSubmit} className="btn btn-primary ml-1">
                                        <span>Xác nhận thông tin báo cáo</span>
                                    </button>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
export default BPPhaseDetailByAGBBO;